import moment from "moment";
import { useEffect } from "react";
import { useWebStoreContext } from "contexts/WebStoreProvider";
import { LS_DOT_MEGAMENU_HIDDEN_AT } from "redux/slices/sticky-sale-tag/helper";

const SHOW_DOT = {
	YES: true,
	NO: false
};

export const useShowHamburgerDotCooldown = (): boolean => {
	const { nowTime } = useWebStoreContext();
	const lastHiddenDate = localStorage.getItem(LS_DOT_MEGAMENU_HIDDEN_AT);

	// @ts-expect-error
	const isServerTimeReady = typeof nowTime?._tzm !== "undefined";
	let cooldownExpired = false;

	if (isServerTimeReady && lastHiddenDate) {
		const lastDate = JSON.parse(lastHiddenDate) as Date;
		cooldownExpired = moment(nowTime).isAfter(moment(lastDate).add(1, "day"));
	}

	useEffect(() => {
		if (cooldownExpired) {
			localStorage.removeItem(LS_DOT_MEGAMENU_HIDDEN_AT);
		}
	}, [cooldownExpired]);

	if (!isServerTimeReady) {
		return SHOW_DOT.NO;
	}

	if (lastHiddenDate) {
		return cooldownExpired ? SHOW_DOT.YES : SHOW_DOT.NO;
	}

	// If there's not last hidden date that means that user have not clicked on a sale active tab
	return SHOW_DOT.YES;
};
